import { PAGINATION } from '@/constants/pagination.constant';
import { MessageType } from '@/types/common';
import { createAppSlice } from '../createAppSlice';
import { transformerArray } from '../transformer';


type NutritionalMenuCalculatorSliceState = {
    loading: boolean;
    loadingFilterDish: boolean;
    loadingResult: boolean;
    loadingFilterTargetProfile: boolean;
    listDishAge: DishAge[];
    listDishCookingMethod: DishCookingMethod[];
    listSourceDish: ListSourceDish[];
    listRegionDish: RegionDish[];
    listStructureMealDish: StructureMealDish[];
    message?: MessageType;
    pagination: Pagination;
    listDish: Dish[]
    paginationFilterDish: Pagination;
    listIngredient: IngredientNutritionalMenuCalculator[];
    listTargetProfile: TargetProfileListNutritionalMenuCalculator[];
    listResult: ResultCalculateNutrition | null;
    paginationFilterTargetProfile: Pagination;
};

const initialState: NutritionalMenuCalculatorSliceState = {
    loading: false,
    loadingFilterDish: false,
    loadingResult: false,
    loadingFilterTargetProfile: false,
    listDishAge: [],
    listDishCookingMethod: [],
    listSourceDish: [],
    listStructureMealDish: [],
    listRegionDish: [],
    pagination: PAGINATION,
    listDish: [],
    paginationFilterDish: PAGINATION,
    listIngredient: [],
    listTargetProfile: [],
    listResult: null,
    paginationFilterTargetProfile: PAGINATION
};

export const nutritionalMenuCalculatorSlice = createAppSlice({
    name: 'nutritionalMenuCalculator',
    initialState,
    reducers: (create) => ({
        getListDishAge: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('dish-age-range/list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listDishAge = transformerArray(action.payload);
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listDishAge = [];
                }
            }
        ),
        getListDishCookingMethod: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('dish-cooking-method/list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listDishCookingMethod = transformerArray(action.payload);
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listDishCookingMethod = [];
                }
            }
        ),
        getListSourceDish: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('dish-external-type/list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listSourceDish = transformerArray(action.payload);
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listSourceDish = [];
                }
            }
        ),
        getListStructureMealDish: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('dish-meal-structure/list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listStructureMealDish = transformerArray(action.payload);
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listStructureMealDish = [];
                }
            }
        ),
        getListDishRegion: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('dish-management/dish-region/list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listRegionDish = transformerArray(action.payload);
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listRegionDish = [];
                }
            }
        ),
        getListIngredient: create.asyncThunk(
            async () => {
                const response = await apiFetcher.get('nutrition-calculation/ingredient-list');
                return response.data;
            },
            {
                pending: (state) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.listIngredient = action.payload;
                },
                rejected: (state) => {
                    state.loading = false;
                    state.listIngredient = [];
                }
            }
        ),
        getListFilterDishObject: create.asyncThunk(
            async (
                payload?: { query?: FilterDishNutritionalMenuCalculator; offset?: number; limit?: number }
            ) => {
                const { query, offset = 1, limit = 10 } = payload || {};
                const params = new URLSearchParams();
                params.append('offset', offset.toString());
                params.append('limit', limit.toString());

                const url = `dish-management/list?${params.toString()}`;

                const response = await apiFetcher.post(url, query || {});
                return response.data;
            },
            {
                pending: (state) => {
                    state.loadingFilterDish = true;
                },
                fulfilled: (state, action) => {
                    state.loadingFilterDish = false;
                    state.listDish = transformerArray(action.payload.listData);
                    state.paginationFilterDish = action.payload.paging;
                },
                rejected: (state) => {
                    state.loadingFilterDish = false;
                    state.listDish = [];
                    state.paginationFilterDish = PAGINATION;
                }
            }
        ),
        getListTargetProfile: create.asyncThunk(
            async (
                payload?: { query?: FilterTargetProfileNutritionalMenuCalculator; offset?: number; limit?: number }
            ) => {
                const { query, offset = 1, limit = 10 } = payload || {};
                const params = new URLSearchParams();
                params.append('page', offset.toString());
                params.append('limit', limit.toString());

                const url = `nutrition-calculation/target-profile-list?${params.toString()}`;

                const response = await apiFetcher.post(url, query || {});
                return response.data;
            },
            {
                pending: (state) => {
                    state.loadingFilterTargetProfile = true;
                },
                fulfilled: (state, action) => {
                    state.loadingFilterTargetProfile = false;
                    state.listTargetProfile = action.payload.listData;
                    state.paginationFilterTargetProfile = action.payload.paging;
                },
                rejected: (state) => {
                    state.loadingFilterTargetProfile = false;
                    state.listTargetProfile = [];
                    state.paginationFilterTargetProfile = PAGINATION;
                }
            }
        ),
        createNutritionCalculate: create.asyncThunk(
            async (
                payload: CalculateNutrition
            ) => {
                const response = await apiFetcher.post('nutrition/calculate-nutrition', payload);
                return response.data;
            },
            {
                pending: (state) => {
                    state.loadingResult = true;
                },
                fulfilled: (state, action) => {
                    state.loadingResult = false;
                    state.listResult = action.payload;
                },
                rejected: (state) => {
                    state.loadingResult = false;
                    state.listResult = null;
                }
            }
        ),

        resetListFilterDish: create.reducer((state) => {
            state.listDish = [];
            state.paginationFilterDish = PAGINATION;
        }),
        resetListFilterTargetProfile: create.reducer((state) => {
            state.listTargetProfile = [];
            state.paginationFilterTargetProfile = PAGINATION;
        }),
        resetMessages: create.reducer((state) => {
            state.message = undefined;
        }),
    }),
    selectors: {
        watchListDishAge: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listDishAge,
        watchListDishCookingMethod: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listDishCookingMethod,
        watchListSourceDish: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listSourceDish,
        watchListStructureMealDish: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listStructureMealDish,
        watchListRegionDish: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listRegionDish,
        watchListFilterDish: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listDish,
        watchDishMessage: (nutritionalMenuCalculator) => nutritionalMenuCalculator.message,
        watchDishPagination: (nutritionalMenuCalculator) => nutritionalMenuCalculator.pagination,
        watchNutritionalMenuCalculatorLoading: (nutritionalMenuCalculator) => nutritionalMenuCalculator.loading,
        watchNutritionalMenuCalculatorDishLoading: (nutritionalMenuCalculator) => nutritionalMenuCalculator.loadingFilterDish,
        watchPaginationFilterDish: (nutritionalMenuCalculator) => nutritionalMenuCalculator.paginationFilterDish,
        watchListIngredient: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listIngredient,
        watchListTargetProfile: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listTargetProfile,
        watchListResult: (nutritionalMenuCalculator) => nutritionalMenuCalculator.listResult,
        watchLoadingFilterTargetProfile: (nutritionalMenuCalculator) => nutritionalMenuCalculator.loadingFilterTargetProfile,
        watchPaginationFilterTargetProfile: (nutritionalMenuCalculator) => nutritionalMenuCalculator.paginationFilterTargetProfile
    }
});

export const {
    watchListDishAge,
    watchListDishCookingMethod,
    watchListSourceDish,
    watchListStructureMealDish,
    watchListRegionDish,
    watchListFilterDish,
    watchDishMessage,
    watchDishPagination,
    watchNutritionalMenuCalculatorLoading,
    watchNutritionalMenuCalculatorDishLoading,
    watchPaginationFilterDish,
    watchListIngredient,
    watchListTargetProfile,
    watchListResult,
    watchLoadingFilterTargetProfile,
    watchPaginationFilterTargetProfile
} = nutritionalMenuCalculatorSlice.selectors;

export const {
    getListFilterDishObject,
    getListDishAge,
    getListDishCookingMethod,
    getListSourceDish,
    getListStructureMealDish,
    getListDishRegion,
    resetMessages,
    resetListFilterDish,
    resetListFilterTargetProfile,
    getListIngredient,
    getListTargetProfile,
    createNutritionCalculate
} = nutritionalMenuCalculatorSlice.actions;
